<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12"> <v-card color="transparent" elevation="0" class="text-center pb-10 mt-n5">
          <span style="color: #e1dada;">
            <h1 style="font-size: 2em;" class="mb-5">Rolls</h1>
          </span>
          <v-divider dark style="color:yellow;" class="my-5"></v-divider>

          <v-row justify="center"> <v-col cols="12" md="9" lg="7">
              <div v-if="loading" style="color: #e1dada;">Loading rolls...</div>

              <div v-if="error" style="color: red;">
                Failed to load rolls. {{ error.message || error }}
              </div>
              <v-row justify="center">
              <v-col>
              <v-list dense color="transparent" v-if="!loading && !error && rolls.length > 0">
                <v-list-item
                  v-for="(item, index) in sortedRolls"
                  :key="item.userId + '-' + index"
                  class="mb-1 roll-list-item-wrapper"
                  :ripple="false"
                >
                  <v-list-item-content class="pa-0">
                    <v-row  no-gutters class="ma-0 pa-0">
                      <v-col cols="auto" class="d-flex">
                        <div class="info-box roll-display-box" style="margin-right: 4px;">
                          <span>{{ item.roll }}</span>
                        </div>
                      </v-col>
                      <v-col >
                        <div class="info-box user-display-box">
                          <div style="font-size: 1.0em; line-height: 1.3;">
                            <strong>{{ item.nickName }}</strong>
                            <span v-if="item.userName && item.userName !== item.nickName" style="font-size: 0.8em; opacity: 0.8; margin-left: 5px;">
                              ({{ item.userName }})
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            </v-row>
              <div v-if="!loading && !error && rolls.length === 0" style="color: #e1dada;">
                No rolls have been recorded for this generator.
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import Store from "../store/index";

export default {
  data() {
    return {
      rolls: [],
      loading: false,
      error: null,

    };
  },
  computed: {
    sortedRolls() {
      return [...this.rolls].sort((a, b) => {
        const rollA = Number(a.roll);
        const rollB = Number(b.roll);
        return rollB - rollA;
      });
    }
  },
  created() {
    this.fetchRollsData();
    document.title = "Raid-Helper - RollGenerator";
  },
  methods: {
    async fetchRollsData() {
      this.loading = true;
      this.error = null;
      try {
        const id = this.$route.params.id;
        const response = await axios.get(Store.state.url + `/api/v3/rollgenerators/${id}`);
        if (response.data && Array.isArray(response.data.rolls)) {
          this.rolls = response.data.rolls;
        } else {
          this.rolls = [];
        }
      } catch (err) {
        console.error("Error fetching roll generator data:", err);
        this.error = err.response ? err.response.data : err;
      } finally {
        this.loading = false;
      }
    },
}
}
</script>

<style>
.roll-list-item-wrapper {
  background-color: transparent !important;
}

.info-box {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  background-color: #2E2E32;
  color: #e1dada;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

.roll-display-box {
  width: 70px;
  padding: 2px 8px;
  font-weight: 700;
  font-size: 2em;
  color: #FFFFFF;
  align-items: center;
  text-align: center;
}

.user-display-box {
  padding: 2px 16px;
  align-items: flex-start;
}

.user-display-box strong {
  color: #FFFFFF;
  font-weight: 600;
  margin-bottom: 2px;
}

.user-display-box span {
  font-size: 0.85em;
  opacity: 0.75;
}

.v-list.transparent {
  background-color: transparent !important;
}
</style>